export const useCoinsPerDollarCopy = () => {
  const { cluster } = useConfigStore();
  const { isUsa } = useClusterCountryConfig();
  const { t } = useI18n();

  return computed((): string | null => {
    if (isUsa) {
      return null;
    }

    if (!cluster?.coinsPerDollar) {
      return null;
    }

    return t('unified.learn.trending.coinsPerDollar', { coins: cluster.coinsPerDollar });
  });
};
